import {VolumeInventorySnapshot} from "../../../model/volume-inventory-snapshot";
import {otsBaseApi} from "../../ots-api";
import {VolumeInventorySearchCriteria} from "../../../model/search/volume-inventory-search-criteria";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["VolumeInventory"]});

export const volumeInventoryApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchVolumeInventory: builder.query<VolumeInventorySnapshot[], VolumeInventorySearchCriteria>({
      query: (arg) => ({
        url: `/inventory/volume/search`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        return [{type: "VolumeInventory", id: "LIST"}];
      },
    }),
  })
});

export const {
  useSearchVolumeInventoryQuery,
} = volumeInventoryApi;
